import Glide, { Controls, Breakpoints } from '@glidejs/glide/dist/glide.modular.esm'

window.addEventListener('load', function() {
  var sliders = document.querySelectorAll('.glide-testimonials');

  for (var i = 0; i < sliders.length; i++) {
    var glide = new Glide(sliders[i], {
      type: 'carousel',
      startAt: 0,
      perView: 4,
      breakpoints: {
        1199: {
            perView: 3
        },
        991: {
            perView: 2
        },
        767: {
            perView: 1
        },
      }
    });
    
    glide.mount({ Controls, Breakpoints });
  }
});